export default "__VITE_ASSET__0wTx70cw__"